<div class="col-12 md:col-12 lg:col-12 container">

  <div class="grid container-header">

    <div class="col-12 md:col-12 lg:col-6">
      <span class="title">{{ 'TRANSLATE.NEW.ELIGIBILITY' | translate }}</span>
    </div>
  </div>

  <div class="col-12 md:col-12 lg:col-12 container-body">
    @if (userform) {
    <form [formGroup]="userform" (ngSubmit)="buttonSave()">

      <div class="col-12 md:col-12 lg:col-12 new-itens">

        <div class="grid col-12 md:col-12 lg:col-12 element-text-select">

          <div class="col-12 md:col-6 lg:col-4 element-option-select">
            <label class="element-option-select-filter" for="country">{{ 'TRANSLATE.COUNTRY' | translate }}
            </label>
            <p-dropdown [options]="listCountries" id="country" [autoDisplayFirst]="false"
              placeholder="{{ 'TRANSLATE.SELECT' | translate }}"
              [emptyMessage]="'TRANSLATE.NO.RESULT.FOUND' | translate"
              [emptyFilterMessage]="'TRANSLATE.NO.RESULT.FOUND' | translate" formControlName="selectCountry"
              (onChange)="countryChange($event)" [style]="{'minWidth': '100%'}">
              <ng-template pTemplate="item" let-item>
                {{item?.label | translate}}
              </ng-template>
              <ng-template pTemplate="selectedItem" let-item>
                {{ item?.label ? (item.label | translate) : ('TRANSLATE.SELECT' | translate) }}
              </ng-template>
            </p-dropdown>

            @if (submitted && userform.controls['selectCountry'].invalid) {
            <p-message class="client-data-message" severity="error" text="{{ 'TRANSLATE.SELECT.COUNTRY' | translate }}">
            </p-message>
            }
          </div>

          <div class="col-12 md:col-6 lg:col-4 element-option-select position-top-select-two">

            <label class="selected-edit-title" for="productNew">{{ 'TRANSLATE.ID.PRODUCT.NAME' | translate }}
            </label>
            <p-autoComplete [placeholder]="placeholderProduct | translate" [suggestions]="productArray"
              [emptyMessage]="'TRANSLATE.NO.RESULT.FOUND' | translate" id="productNew" field="name"
              formControlName="selectProduct" (completeMethod)="searchProducts($event)"
              (onSelect)="onProductSelect($event)" [style]="{'width': '100%'}" [dropdown]="true" autoHighlight>
              <ng-template pTemplate="item" let-item>
                <span>{{ formatProductIdName(item) }}</span>
              </ng-template>
            </p-autoComplete>

            @if (isProductDisabled) {
            <small class="field-hint">{{ 'TRANSLATE.SELECT.COUNTRY.FIRST' | translate }}</small>
            }
            @if (submitted && userform.controls['selectProduct'].invalid) {
            <p-message class="client-data-message" severity="error" text="{{ 'TRANSLATE.SELECT.PRODUCT' | translate }}">
            </p-message>
            }
          </div>

          <div class="col-12 md:col-6 lg:col-4 element-option-select position-top-select-two"
            [ngClass]="{'position-select': products.length > 0}">

            <label class="selected-edit-title" for="coverageNew">{{ 'TRANSLATE.COVERAGE' | translate }}
            </label>
            <p-autoComplete [placeholder]="placeholderCoverage | translate" [suggestions]="coveragesConcat"
              [emptyMessage]="'TRANSLATE.NO.RESULT.FOUND' | translate" id="coverageNew" field="label"
              formControlName="selectCoverage" (completeMethod)="searchCoverages($event)"
              (onSelect)="coverageChange($event)" [style]="{'width': '100%'}" [dropdown]="true" autoHighlight>
              <ng-template pTemplate="item" let-item>
                <span>{{ item.label }}</span>
              </ng-template>
            </p-autoComplete>

            @if (isCoverageDisabled) {
            <small class="field-hint">{{ 'TRANSLATE.ERROR.PLEASE.SELECT.PRODUCT' | translate }}</small>
            }
            @if (submitted && userform.controls['selectCoverage'].invalid) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.SELECT.COVERAGE' | translate }}">
            </p-message>
            }
          </div>

        </div>

        <div class="grid col-12 md:col-12 lg:col-12 element-text-select">

          <div class="col-12 md:col-6 lg:col-4 element-option-select select-width">
            <label class="element-option-select-filter" for="canalVendasNew">{{ 'TRANSLATE.SALES.CHANNEL' | translate }}
            </label>
            <p-dropdown [options]="listSalesChannel" id="canalVendasNew" [autoDisplayFirst]="false"
              placeholder="{{ 'TRANSLATE.SELECT' | translate }}"
              [emptyMessage]="'TRANSLATE.NO.RESULT.FOUND' | translate"
              [emptyFilterMessage]="'TRANSLATE.NO.RESULT.FOUND' | translate" formControlName="selectCanalVendas"
              (onChange)="canalVendasChange($event)" [style]="{'minWidth': '100%'}">
              <ng-template pTemplate="item" let-item>
                {{item?.label | translate}}
              </ng-template>
              <ng-template pTemplate="selectedItem" let-item>
                {{ item?.label ? (item.label | translate) : ('TRANSLATE.SELECT' | translate) }}
              </ng-template>
            </p-dropdown>

            @if (submitted && userform.controls['selectCanalVendas'].invalid) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.SELECT.SALES.CHANNEL' | translate }}">
            </p-message>
            }
          </div>

          <div class="col-12 md:col-6 lg:col-4 element-option-select select-width position-top-select">
            <label class="element-option-select-filter" for="statusNew">{{ 'TRANSLATE.STATUS' | translate }}
            </label>
            <p-dropdown [options]="listStatus" id="statusNew" [autoDisplayFirst]="false"
              placeholder="{{ 'TRANSLATE.SELECT' | translate }}"
              [emptyMessage]="'TRANSLATE.NO.RESULT.FOUND' | translate"
              [emptyFilterMessage]="'TRANSLATE.NO.RESULT.FOUND' | translate" formControlName="selectStatus"
              (onChange)="statusChange($event)" [style]="{'minWidth':'100%'}">
              <ng-template pTemplate="item" let-item>
                {{item?.label | translate}}
              </ng-template>
              <ng-template pTemplate="selectedItem" let-item>
                {{ item?.label ? (item.label | translate) : ('TRANSLATE.SELECT' | translate) }}
              </ng-template>
            </p-dropdown>

            @if (submitted && userform.controls['selectStatus'].invalid) {
            <p-message class="client-data-message" severity="error" text="{{ 'TRANSLATE.SELECT.STATUS' | translate }}">
            </p-message>
            }
          </div>

          <div class="col-12 md:col-6 lg:col-4 element-option-select select-width position-top-select">
            <label class="element-option-select-filter" for="yearVehicleNew">{{ 'TRANSLATE.YEAR.VEHICLE' | translate }}
            </label>
            <p-dropdown [options]="listYearVehicle" id="yearVehicleNew" [autoDisplayFirst]="false"
              placeholder="{{ 'TRANSLATE.SELECT' | translate }}"
              [emptyMessage]="'TRANSLATE.NO.RESULT.FOUND' | translate"
              [emptyFilterMessage]="'TRANSLATE.NO.RESULT.FOUND' | translate" formControlName="selectYearVehicles"
              (onChange)="yearVehicleChange($event)" [style]="{'minWidth':'100%'}">
              <ng-template pTemplate="item" let-item>
                {{item?.label | translate}}
              </ng-template>
              <ng-template pTemplate="selectedItem" let-item>
                {{ item?.label ? (item.label | translate) : ('TRANSLATE.SELECT' | translate) }}
              </ng-template>
            </p-dropdown>

            @if (submitted && userform.controls['selectYearVehicles'].invalid) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.SELECT.YEAR.VEHICLE' | translate }}">
            </p-message>
            }
          </div>
        </div>

        <div class="grid col-12 md:col-12 lg:col-12 element-text-select">

          <div class="col-12 md:col-6 lg:col-4 element-option-select select-width">

            <label class="element-option-select-filter" for="vehicleNew">{{ 'TRANSLATE.VEHICLE' | translate }}
            </label>
            <p-autoComplete [placeholder]="placeholderVehicle | translate" [suggestions]="vehicleLineConcat"
              [emptyMessage]="'TRANSLATE.NO.RESULT.FOUND' | translate" id="vehicleNew" field="label"
              formControlName="selectVehicleLines" (completeMethod)="searchVehicleLines($event)"
              (onSelect)="vehicleLineChange($event)" [style]="{'width': '100%'}" [dropdown]="true" autoHighlight>
              <ng-template pTemplate="item" let-item>
                <span>{{ item.label }}</span>
              </ng-template>
            </p-autoComplete>

            @if (isVehicleLineDisabled) {
            <small class="field-hint">{{ 'TRANSLATE.SELECT.YEAR.VEHICLE' | translate }}</small>
            }
            @if (submitted && userform.controls['selectVehicleLines'].invalid) {
            <p-message class="client-data-message" severity="error" text="{{ 'TRANSLATE.SELECT.VEHICLE' | translate }}">
            </p-message>
            }
          </div>

          <div class="col-12 md:col-6 lg:col-4 element-add-edit position-top-select">
            <label class="element-add-edit-label" for="monthsOfferNew">{{ 'TRANSLATE.MONTHS.OFFER' | translate }}
            </label>
            <input class="element-add-edit-input" id="monthsOfferNew" formControlName="inputMonthsOffer" type="text"
              minlength="1" maxlength="3" (input)="formatNumber($event)" pInputText>

            @if (userform.controls['inputMonthsOffer'].pending) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.INFORM.NUMBER.MONTHS.OFFER' | translate }}">
            </p-message>
            }
          </div>

          <div class="col-12 md:col-6 lg:col-4 element-option-select select-width position-top-select">
            <label class="element-option-select-filter" for="warrantyCostNew">{{ 'TRANSLATE.WARRANTY.COST' | translate
              }}
            </label>
            <p-autoComplete [placeholder]="placeholderField | translate" [suggestions]="warrantyPricesConcat"
              [emptyMessage]="'TRANSLATE.NO.RESULT.FOUND' | translate" id="warrantyCostNew" field="label"
              [style]="{'minWidth': '100%'}" (completeMethod)="searchWarrantyCost($event)"
              (onSelect)="warrantyCostChange($event)" [dropdown]="true" autoHighlight>
              <ng-template pTemplate="item" let-item>
                <span>{{ item.label }}</span>
              </ng-template>
            </p-autoComplete>


          </div>
        </div>

        <div class="grid col-12 md:col-12 lg:col-12 element-text-select">

          <div class="col-12 md:col-6 lg:col-4 element-option-select select-width">
            <label class="element-option-select-filter" for="serviceCostNew">{{ 'TRANSLATE.SERVICE.COST' | translate }}
            </label>
            <p-autoComplete [placeholder]="placeholderField | translate" [suggestions]="serviceCostPricesConcat"
              [emptyMessage]="'TRANSLATE.NO.RESULT.FOUND' | translate" id="serviceCostNew" field="label"
              [style]="{'minWidth': '100%'}" (completeMethod)="searchServiceCost($event)"
              (onSelect)="serviceCostChange($event)" [dropdown]="true" autoHighlight>
              <ng-template pTemplate="item" let-item>
                <span>{{ item.label }}</span>
              </ng-template>
            </p-autoComplete>


          </div>

          <div class="col-12 md:col-6 lg:col-4 element-option-select select-width position-top-select">
            <label class="element-option-select-filter" for="fordCostNew">{{ 'TRANSLATE.FORDCOST.PRICE' | translate }}
            </label>
            <p-autoComplete [placeholder]="placeholderField | translate" [suggestions]="fordCostPricesConcat"
              [emptyMessage]="'TRANSLATE.NO.RESULT.FOUND' | translate" id="fordCostNew" field="label"
              [style]="{'minWidth': '100%'}" (completeMethod)="searchFordCost($event)"
              (onSelect)="fordCostChange($event)" [dropdown]="true" autoHighlight>
              <ng-template pTemplate="item" let-item>
                <span>{{ item.label }}</span>
              </ng-template>
            </p-autoComplete>


          </div>

          <div class="col-12 md:col-6 lg:col-4 element-option-select select-width position-top-select">
            <label class="element-option-select-filter" for="sellerPriceNew">{{ 'TRANSLATE.SELLER.PRICE' | translate }}
            </label>
            <p-autoComplete [placeholder]="placeholderField | translate" [suggestions]="sellerPricePricesConcat"
              [emptyMessage]="'TRANSLATE.NO.RESULT.FOUND' | translate" id="sellerPriceNew" field="label"
              [style]="{'minWidth': '100%'}" (completeMethod)="searchSellerPrice($event)"
              (onSelect)="sellerPriceChange($event)" [dropdown]="true" autoHighlight>
              <ng-template pTemplate="item" let-item>
                <span>{{ item.label }}</span>
              </ng-template>
            </p-autoComplete>

            @if (submitted && (selectedSellerPrice === null || selectedSellerPrice === undefined || sellerPriceName <=
              0)) { <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.SELECT.SELLER.PRICE' | translate }}">
              </p-message>
              }
          </div>
        </div>

        <div class="grid col-12 md:col-12 lg:col-12 element-text-select">

          <div class="col-12 md:col-6 lg:col-4 element-option-select select-width top-space">
            <label class="element-option-select-filter" for="customerPrice3New">{{ 'TRANSLATE.SELECT.PRICE.CUSTOMER' |
              translate }}
            </label>
            <p-autoComplete [placeholder]="placeholdercustomerPrices | translate" [suggestions]="customersPricesConcat"
              [emptyMessage]="'TRANSLATE.NO.RESULT.FOUND' | translate" id="customerPrice3New" field="label"
              formControlName="selectedCustomerPrices" [style]="{'minWidth': '100%'}"
              (completeMethod)="searchCustomerPrice($event)" (onSelect)="customerPriceChange($event)" [dropdown]="true"
              autoHighlight>
              <ng-template pTemplate="item" let-item>
                <span>{{ item.label }}</span>
              </ng-template>
            </p-autoComplete>

            @if (submitted && userform.controls['selectedCustomerPrices'].invalid) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.SELECT.CUSTOMER.PRICE' | translate }}">
            </p-message>
            }
          </div>

        </div>

        <div class="grid col-12 md:col-12 lg:col-12 element-text-select">
          <div class="col-12 md:col-12 lg:col-12 element-option-select select-width description-width textarea-row">
            <label class="element-option-select-filter" for="policyDescriptionNew">{{
              'TRANSLATE.DESCRIPTION.ELIGIBILITY' | translate }}
            </label>
            <textarea class="element-add-edit-input large-text" id="policyDescriptionNew"
              formControlName="inputPolicyDescription" maxlength="50" pInputTextarea></textarea>

            <div class="char-counter">
              {{ contCaractereres() }} {{ 'TRANSLATE.MAX.CHARACTERS.50' | translate }}
            </div>
          </div>
        </div>

      </div>

      <div class="actions-section">
        <div class="col-12 md:col-12 lg:col-12 button-position">

          <button id="btnReturn" class="btn-return app-clean-button" type="button" (click)="buttonReturn()"
            [disabled]="isSaving">
            <i class="pi pi-arrow-left"></i>
            <span class="btn-return-label">{{ 'TRANSLATE.RETURN' | translate }}</span>
          </button>

          <app-cta-button [label]="'TRANSLATE.SAVE'" [loadingLabel]="'TRANSLATE.SAVING'" [successState]="isCtaSuccess"
            [autoFocusOnSuccess]="false" [loading]="isSaving" (buttonClick)="buttonSave()">
          </app-cta-button>

        </div>
      </div>

    </form>
    }
  </div>
</div>